//IE対策
//import 'babel-polyfill';
//さらにIE対策 ( https://stackoverflow.com/questions/36484156/es6-fetch-is-undefined )
import "isomorphic-fetch"
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Link } from 'react-router-dom'
import queryString from 'query-string'
import ReactTooltip from 'react-tooltip'
import MediaQuery from 'react-responsive'
const format = require('date-fns/format');


document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(
        <App />,
        document.getElementById('calendar'),
    )
});

const App = () => (
    <BrowserRouter>
        <div>
            <Route path='/' component={Calendar} />
        </div>
    </BrowserRouter>
)

class Calendar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            // Accordion status.
            accordionOpened:          false,
            showIconLegendPc:           false,
            showIconLegendSp:           false,

            // Values from GET parameters.
            calendarName:             props.location.pathname.split('/')[2],
            selectedMonth:            queryString.parse(props.location.search).selectedMonth,
            secretKeys:               queryString.parse(props.location.search).secretKeys,
            onlySecret:               queryString.parse(props.location.search).onlySecret === 'true',
            planIds:                  queryString.parse(props.location.search).planIds,
            onlySpecifiedPlanIds:     true,

            //202506 URLでプラン種別を絞り込めるように変更
            standardRsvn:             queryString.parse(props.location.search).planType === 'standardRsvn',
            soloRsvn:                 queryString.parse(props.location.search).planType === 'soloRsvn',

            // Values from plan search form (day options).
            monday:                   false,
            tuesday:                  false,
            wednesday:                false,
            thursday:                 false,
            friday:                   false,
            saturday:                 false,
            sunday:                   false,
            holiday:                  false,
            weekdays:                 false,
            weekend:                  false,

            // Values from plan search form (hour options).
            hour5:                    false,
            hour6:                    false,
            hour7:                    false,
            hour8:                    false,
            hour9:                    false,
            hour10:                   false,
            hour11:                   false,
            hour12:                   false,
            hourRequest:              false,

            // Values from plan search form (plan feature options).
            twosome:                  false,
            flagLunch:                false,
            flagThrough:              false,

            flag01:                   false,
            flag02:                   false,
            flag03:                   false,
            flag04:                   false,
            flag05:                   false,
            flag06:                   false,
            flag07:                   false,
            flag08:                   false,
            flag09:                   false,
            flag10:                   false,
            flag11:                   false,
            flag12:                   false,
            flag13:                   false,
            flag14:                   false,
            flag15:                   false,
            flag16:                   false,
            flag17:                   false,
            flag18:                   false,
            flag19:                   false,
            flag20:                   false,

            // Values from plan search form (display order).
            displayOrder:            'recommend',

            // Values from API (main data part).
            monthCalendars:           [],
            months:                   [],
            plans:                    [],

            // Values from API (settings part).
            planTypes:                [],
            caddieTypes:              [],
            cartTypes:                [],
            roundTypes:               [],
            courses:                  [],
            flags:                    [],

            twosomeOnPlanIconUrl:     '',
            twosomeOffPlanIconUrl:    '',
            lunchOnPlanIconUrl:     '',
            lunchOffPlanIconUrl:    '',
            throughOnPlanIconUrl:     '',
            throughOffPlanIconUrl:    '',

            webReservableMark:        [],
            telReservableMark:        [],
            requestableMark:          [],
            cancelReservableMark:     [], // 11/13 キャンセル待ち機能追加対応

            calendarFreeText:         '',

            // Last updated timestamp.
            updatedAt:                '',

            datePlans:                [],
            selectedDate:             {},

            myRef:                      React.createRef(),

            // Flag to display calendar after data load.
            isLoading:                false,
        };
    }

    // Called after render()'s first run.
    componentDidMount() {
        this.fetchCalendarData(false);
    }

    // Assign fetched values from calendar data API to React State object.
    fetchCalendarData(refresh){
        this.setState({isLoading: true});

        let getParams = [];
        if(this.state.secretKeys){
            getParams.push(['secretKeys', this.state.secretKeys]);
        }
        if(refresh){
            getParams.push(['refresh', 'true']);
        }

        let calendarDataUrl = `/calendars/${this.state.calendarName}/calendar/data${this.generateGetParamsString(getParams)}`;

        const fetchData = fetch(calendarDataUrl)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(response => {return response.json();});


        Promise.all([fetchData]).then((values) => {
            this.setState({ months:           Object.keys(values[0].monthCalendars)});
            if(!this.state.selectedMonth){
                this.setState({selectedMonth: this.state.months[0]});
            }

            this.setState({ monthCalendars:   values[0].monthCalendars});
            this.setState({ plans:            values[0].plans });

            this.setState({ planTypes:        values[0].planTypes });
            this.setState({ caddieTypes:      values[0].caddieTypes });
            this.setState({ cartTypes:        values[0].cartTypes });
            this.setState({ roundTypes:       values[0].roundTypes });
            this.setState({ courses:          values[0].courses });
            this.setState({ flags:            values[0].flags });

            this.setState({ twosomeOnPlanIconUrl:    values[0].twosomeOnPlanIconUrl});
            this.setState({ twosomeOffPlanIconUrl:   values[0].twosomeOffPlanIconUrl});
            this.setState({ lunchOnPlanIconUrl:    values[0].lunchOnPlanIconUrl});
            this.setState({ lunchOffPlanIconUrl:   values[0].lunchOffPlanIconUrl});
            this.setState({ throughOnPlanIconUrl:    values[0].throughOnPlanIconUrl});
            this.setState({ throughOffPlanIconUrl:   values[0].throughOffPlanIconUrl});

            this.setState({ webReservableMark: values[0].webReservableMark });
            this.setState({ telReservableMark: values[0].telReservableMark });
            this.setState({ requestableMark:   values[0].requestableMark });
            this.setState({ cancelReservableMark: values[0].cancelReservableMark }); // 11/13 キャンセル待ち機能追加対応

            this.setState({ calendarFreeText:  values[0].calendarFreeText});

            this.setState({ updatedAt:        values[0].updatedAt });
            this.setState({ isLoading:        false});
        });
    }

    //https://stackoverflow.com/questions/51698525/react-js-using-back-button-to-get-previous-searches
    componentDidUpdate(prevProps) {
        // Update State object once GET parameters have changed.
        if (prevProps.location.search !== this.props.location.search) {
            this.setStateByGetParams();
        }
    }

    setStateByGetParams() {
        const params = queryString.parse(this.props.location.search);
        this.setState({selectedMonth: params.selectedMonth});
        this.setState({secretKeys:    params.secretKeys});
        this.setState({onlySecret:    params.onlySecret === 'true'});
        this.setState({planIds:       params.planIds});
    };

    generateGetParamsString(params) {
        if(!params){ return ''; }

        let getParam = '';

        params.forEach(function(v, i){
            getParam += i === 0 ? '?' : '&';
            getParam += v[0];
            getParam += '=';
            getParam += v[1];
        });
        return getParam;
    }

    toggleAccordion(){
        this.setState({accordionOpened: !this.state.accordionOpened});
    }

    unselectDate(){
        this.setState({selectedDate: {}});
        this.setState({datePlans: []});
    }

    handleOnlySpecifiedPlanIdsSelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'onlySpecifiedPlanIds':
                this.setState({onlySpecifiedPlanIds: value});
                break;
        }
    }

    handleRsvnTypeSelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'standardRsvn':
                this.setState({standardRsvn: value});
                break;
            case 'soloRsvn':
                this.setState({soloRsvn: value});
                break;
        }
    }

    handleOnlySecretSelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'onlySecret':
                this.setState({onlySecret: value});
                break;
        }
    }

    handleWdaySelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'monday':
                this.setState({monday:    value});
                break;
            case 'tuesday':
                this.setState({tuesday:   value});
                break;
            case 'wednesday':
                this.setState({wednesday: value});
                break;
            case 'thursday':
                this.setState({thursday:  value});
                break;
            case 'friday':
                this.setState({friday:    value});
                break;
            case 'saturday':
                this.setState({saturday:  value});
                break;
            case 'sunday':
                this.setState({sunday:    value});
                break;
            case 'holiday':
                this.setState({holiday:   value});
                break;
            case 'weekdays':
                this.setState({weekdays:  value});
                break;
            case 'weekend':
                this.setState({weekend:   value});
                break;
            default:
                break;
        }
    }

    handleHourSelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'hour5':
                this.setState({hour5:       value});
                break;
            case 'hour6':
                this.setState({hour6:       value});
                break;
            case 'hour7':
                this.setState({hour7:       value});
                break;
            case 'hour8':
                this.setState({hour8:       value});
                break;
            case 'hour9':
                this.setState({hour9:       value});
                break;
            case 'hour10':
                this.setState({hour10:      value});
                break;
            case 'hour11':
                this.setState({hour11:      value});
                break;
            case 'hour12':
                this.setState({hour12:      value});
                break;
            case 'hourRequest':
                this.setState({hourRequest: value});
                break;
            default:
                break;
        }
    }


    handleFlagSelectorChange(type, value){
        this.unselectDate();
        switch (type) {
            case 'twosome':
                this.setState({twosome:                  value});
                break;
            case 'flagLunch':
                this.setState({flagLunch:                value});
                break;
            case 'flagThrough':
                this.setState({flagThrough:                value});
                break;
            case 'flag01':
                this.setState({flag01: value});
                break;
            case 'flag02':
                this.setState({flag02: value});
                break;
            case 'flag03':
                this.setState({flag03: value});
                break;
            case 'flag04':
                this.setState({flag04: value});
                break;
            case 'flag05':
                this.setState({flag05: value});
                break;
            case 'flag06':
                this.setState({flag06: value});
                break;
            case 'flag07':
                this.setState({flag07: value});
                break;
            case 'flag08':
                this.setState({flag08: value});
                break;
            case 'flag09':
                this.setState({flag09: value});
                break;
            case 'flag10':
                this.setState({flag10: value});
                break;
            case 'flag11':
                this.setState({flag11: value});
                break;
            case 'flag12':
                this.setState({flag12: value});
                break;
            case 'flag13':
                this.setState({flag13: value});
                break;
            case 'flag14':
                this.setState({flag14: value});
                break;
            case 'flag15':
                this.setState({flag15: value});
                break;
            case 'flag16':
                this.setState({flag16: value});
                break;
            case 'flag17':
                this.setState({flag17: value});
                break;
            case 'flag18':
                this.setState({flag18: value});
                break;
            case 'flag19':
                this.setState({flag19: value});
                break;
            case 'flag20':
                this.setState({flag20: value});
                break;
            default:
                break;
        }
    }

    handleOrderSelectorChange(event){
        this.setState({displayOrder: event.target.value});
    }

    handleMonthSelectorChange(value){
        this.setState({selectedMonth: value});
        this.setState({selectedDate: {}});
        this.setState({datePlans: []});

        let getParams = [];
        getParams.push(['selectedMonth', value]);
        if(this.state.secretKeys){
            getParams.push(['secretKeys', this.state.secretKeys]);
            getParams.push(['onlySecret', this.state.onlySecret]);
        }
        if(this.state.planIds){
            getParams.push(['planIds', this.state.planIds]);
        }

        this.props.history.push({
            pathname : this.props.location.pathname,
            search   : this.generateGetParamsString(getParams),
            state    : {
                selectedMonth: value
            }
        })
    }

    handleSpCalendarCellClick(datePlans, date){
        this.setState({datePlans: datePlans});
        this.setState({selectedDate: date});
        this.state.myRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });

    }
    handleIconLegendPc(bool){
        this.setState({showIconLegendPc: bool});
    }

    handleIconLegendSp(){
        this.setState({showIconLegendSp: !this.state.showIconLegendSp});
    }

    clearConditions(){
        if(!this.isInitialState()){
            this.unselectDate();
            this.setState({
                onlySpecifiedPlanIds:     false,
                standardRsvn:             false,
                soloRsvn:                 false,
                onlySecret:               false,

                monday:                   false,
                tuesday:                  false,
                wednesday:                false,
                thursday:                 false,
                friday:                   false,
                saturday:                 false,
                sunday:                   false,
                holiday:                  false,
                weekdays:                 false,
                weekend:                  false,

                hour5:                    false,
                hour6:                    false,
                hour7:                    false,
                hour8:                    false,
                hour9:                    false,
                hour10:                   false,
                hour11:                   false,
                hour12:                   false,
                hourRequest:              false,

                twosome:                  false,
                flagLunch:                false,
                flagThrough:              false,

                flag01:                   false,
                flag02:                   false,
                flag03:                   false,
                flag04:                   false,
                flag05:                   false,
                flag06:                   false,
                flag07:                   false,
                flag08:                   false,
                flag09:                   false,
                flag10:                   false,
                flag11:                   false,
                flag12:                   false,
                flag13:                   false,
                flag14:                   false,
                flag15:                   false,
                flag16:                   false,
                flag17:                   false,
                flag18:                   false,
                flag19:                   false,
                flag20:                   false
            });
        }
    }
    isInitialState(){
        if(    !this.state.onlySpecifiedPlanIds
            && !this.state.standardRsvn
            && !this.state.soloRsvn
            && !this.state.onlySecret

            && !this.state.monday
            && !this.state.tuesday
            && !this.state.wednesday
            && !this.state.thursday
            && !this.state.friday
            && !this.state.saturday
            && !this.state.sunday
            && !this.state.holiday
            && !this.state.weekdays
            && !this.state.weekend

            && !this.state.hour5
            && !this.state.hour6
            && !this.state.hour7
            && !this.state.hour8
            && !this.state.hour9
            && !this.state.hour10
            && !this.state.hour11
            && !this.state.hour12
            && !this.state.hourRequest

            && !this.state.twosome
            && !this.state.flagLunch
            && !this.state.flagThrough

            && !this.state.flag01
            && !this.state.flag02
            && !this.state.flag03
            && !this.state.flag04
            && !this.state.flag05
            && !this.state.flag06
            && !this.state.flag07
            && !this.state.flag08
            && !this.state.flag09
            && !this.state.flag10
            && !this.state.flag11
            && !this.state.flag12
            && !this.state.flag13
            && !this.state.flag14
            && !this.state.flag15
            && !this.state.flag16
            && !this.state.flag17
            && !this.state.flag18
            && !this.state.flag19
            && !this.state.flag20){
            return true;
        } else {
            return false;
        }
    }

    render() {
        if (this.state.hasError) {
            return <p>error</p>;
        }
        if (this.state.isLoading) {
            return <div className="loading"><img src="/images/loading.gif" /></div>;
        }

        return(
            <div>
                <CalendarFreeText calendarFreeText={this.state.calendarFreeText} />

                <div className="card">
                    <div className="card-header">
                        <MediaQuery minWidth={992}>
                            <h3 className="card-title">
                                <div className="plan_filter_btn" onClick={() => this.toggleAccordion()}>
                                    <span>プランの絞り込み</span>
                                </div>
                                <AllClearButton
                                    accordionOpened={this.state.accordionOpened}
                                    onClick={() => this.clearConditions()}
                                />
                            </h3>
                        </MediaQuery>
                        <MediaQuery maxWidth={991}>
                            <div className="plan_filter_btn" onClick={() => this.toggleAccordion()}>
                                <span>プランの絞り込み</span>
                            </div>
                        </MediaQuery>
                    </div>
                    <MediaQuery minWidth={992}>
                        <div className={this.state.accordionOpened ? '' : 'collapse'}>
                            <div className="card-body plan_filter">
                                <div id="narrowing-plan">
                                    <RsvnTypeSelector
                                        standardRsvn={this.state.standardRsvn}
                                        soloRsvn={this.state.soloRsvn}
                                        onChange={(type, value) => this.handleRsvnTypeSelectorChange(type, value)}
                                    />
                                    <OnlySpecifiedPlanIdsSelector
                                        planIds={this.state.planIds}
                                        onlySpecifiedPlanIds={this.state.onlySpecifiedPlanIds}
                                        onChange={(type, value) => this.handleOnlySpecifiedPlanIdsSelectorChange(type, value)}
                                    />
                                    <OnlySecretSelector
                                        secretKeys={this.state.secretKeys}
                                        onlySecret={this.state.onlySecret}
                                        onChange={(type, value) => this.handleOnlySecretSelectorChange(type, value)}
                                    />
                                    <WdaySelector
                                        monday={this.state.monday}
                                        tuesday={this.state.tuesday}
                                        wednesday={this.state.wednesday}
                                        thursday={this.state.thursday}
                                        friday={this.state.friday}
                                        saturday={this.state.saturday}
                                        sunday={this.state.sunday}
                                        holiday={this.state.holiday}
                                        weekdays={this.state.weekdays}
                                        weekend={this.state.weekend}
                                        onChange={(type, value) => this.handleWdaySelectorChange(type, value)}
                                    />
                                    <HourSelector
                                        hour5={this.state.hour5}
                                        hour6={this.state.hour6}
                                        hour7={this.state.hour7}
                                        hour8={this.state.hour8}
                                        hour9={this.state.hour9}
                                        hour10={this.state.hour10}
                                        hour11={this.state.hour11}
                                        hour12={this.state.hour12}
                                        hourRequest={this.state.hourRequest}
                                        onChange={(type, value) => this.handleHourSelectorChange(type, value)}
                                    />
                                    <FlagSelector
                                        twosome={this.state.twosome}
                                        flagLunch={this.state.flagLunch}
                                        flagThrough={this.state.flagThrough}
                                        flag01={this.state.flag01}
                                        flag02={this.state.flag02}
                                        flag03={this.state.flag03}
                                        flag04={this.state.flag04}
                                        flag05={this.state.flag05}
                                        flag06={this.state.flag06}
                                        flag07={this.state.flag07}
                                        flag08={this.state.flag08}
                                        flag09={this.state.flag09}
                                        flag10={this.state.flag10}
                                        flag11={this.state.flag11}
                                        flag12={this.state.flag12}
                                        flag13={this.state.flag13}
                                        flag14={this.state.flag14}
                                        flag15={this.state.flag15}
                                        flag16={this.state.flag16}
                                        flag17={this.state.flag17}
                                        flag18={this.state.flag18}
                                        flag19={this.state.flag19}
                                        flag20={this.state.flag20}
                                        flags={this.state.flags}
                                        onChange={(type, value) => this.handleFlagSelectorChange(type, value)}
                                    />
                                    <AllClearButton
                                        onClick={() => this.clearConditions()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={this.state.accordionOpened ? 'calendar_tools show' : 'calendar_tools'}>
                            <OrderSelector
                                displayOrder={this.state.displayOrder}
                                onChange={(event) => this.handleOrderSelectorChange(event)}
                            />
                            <PcMarkLegend
                                webReservableMark={this.state.webReservableMark}
                                telReservableMark={this.state.telReservableMark}
                                requestableMark={this.state.requestableMark}
                                cancelReservableMark={this.state.cancelReservableMark} // 11/13 キャンセル待ち機能追加対応
                             />
                        </div>
                    </MediaQuery>
                    <MediaQuery maxWidth={991}>
                        <div id="narrowing-plan" className={this.state.accordionOpened ? 'show' : ''}>
                            <RsvnTypeSelector
                                standardRsvn={this.state.standardRsvn}
                                soloRsvn={this.state.soloRsvn}
                                onChange={(type, value) => this.handleRsvnTypeSelectorChange(type, value)}
                            />
                            <OnlySpecifiedPlanIdsSelector
                                planIds={this.state.planIds}
                                onlySpecifiedPlanIds={this.state.onlySpecifiedPlanIds}
                                onChange={(type, value) => this.handleOnlySpecifiedPlanIdsSelectorChange(type, value)}
                            />
                            <OnlySecretSelector
                                secretKeys={this.state.secretKeys}
                                onlySecret={this.state.onlySecret}
                                onChange={(type, value) => this.handleOnlySecretSelectorChange(type, value)}
                            />
                            <FlagSelector
                                twosome={this.state.twosome}
                                flagLunch={this.state.flagLunch}
                                flagThrough={this.state.flagThrough}
                                flag01={this.state.flag01}
                                flag02={this.state.flag02}
                                flag03={this.state.flag03}
                                flag04={this.state.flag04}
                                flag05={this.state.flag05}
                                flag06={this.state.flag06}
                                flag07={this.state.flag07}
                                flag08={this.state.flag08}
                                flag09={this.state.flag09}
                                flag10={this.state.flag10}
                                flag11={this.state.flag11}
                                flag12={this.state.flag12}
                                flag13={this.state.flag13}
                                flag14={this.state.flag14}
                                flag15={this.state.flag15}
                                flag16={this.state.flag16}
                                flag17={this.state.flag17}
                                flag18={this.state.flag18}
                                flag19={this.state.flag19}
                                flag20={this.state.flag20}
                                flags={this.state.flags}
                                onChange={(type, value) => this.handleFlagSelectorChange(type, value)}
                            />
                            <AllClearButton
                                onClick={() => this.clearConditions()}
                            />
                        </div>

                    </MediaQuery>

                </div>

                <MonthSelector
                    months={this.state.months}
                    selectedMonth={this.state.selectedMonth}
                    onClick={(value) => this.handleMonthSelectorChange(value.month)}
                />


                <div id="calendar-container">
                    <MediaQuery minWidth={992}>
                        <PcCalendarTable
                            calendarName={this.state.calendarName}

                            monday={this.state.monday}
                            tuesday={this.state.tuesday}
                            wednesday={this.state.wednesday}
                            thursday={this.state.thursday}
                            friday={this.state.friday}
                            saturday={this.state.saturday}
                            sunday={this.state.sunday}
                            holiday={this.state.holiday}
                            weekdays={this.state.weekdays}
                            weekend={this.state.weekend}

                            hour5={this.state.hour5}
                            hour6={this.state.hour6}
                            hour7={this.state.hour7}
                            hour8={this.state.hour8}
                            hour9={this.state.hour9}
                            hour10={this.state.hour10}
                            hour11={this.state.hour11}
                            hour12={this.state.hour12}
                            hourRequest={this.state.hourRequest}

                            twosome={this.state.twosome}
                            flagLunch={this.state.flagLunch}
                            flagThrough={this.state.flagThrough}

                            displayOrder={this.state.displayOrder}

                            selectedMonth={this.state.selectedMonth}
                            monthCalendars={this.state.monthCalendars}
                            plans={this.state.plans}
                            courses={this.state.courses}

                            twosomeOnPlanIconUrl={this.state.twosomeOnPlanIconUrl}
                            twosomeOffPlanIconUrl={this.state.twosomeOffPlanIconUrl}
                            lunchOnPlanIconUrl={this.state.lunchOnPlanIconUrl}
                            lunchOffPlanIconUrl={this.state.lunchOffPlanIconUrl}
                            throughOnPlanIconUrl={this.state.throughOnPlanIconUrl}
                            throughOffPlanIconUrl={this.state.throughOffPlanIconUrl}

                            webReservableMark={this.state.webReservableMark}
                            telReservableMark={this.state.telReservableMark}
                            requestableMark={this.state.requestableMark}
                            cancelReservableMark={this.state.cancelReservableMark} // 11/13 キャンセル待ち機能追加対応

                            flag01={this.state.flag01}
                            flag02={this.state.flag02}
                            flag03={this.state.flag03}
                            flag04={this.state.flag04}
                            flag05={this.state.flag05}
                            flag06={this.state.flag06}
                            flag07={this.state.flag07}
                            flag08={this.state.flag08}
                            flag09={this.state.flag09}
                            flag10={this.state.flag10}
                            flag11={this.state.flag11}
                            flag12={this.state.flag12}
                            flag13={this.state.flag13}
                            flag14={this.state.flag14}
                            flag15={this.state.flag15}
                            flag16={this.state.flag16}
                            flag17={this.state.flag17}
                            flag18={this.state.flag18}
                            flag19={this.state.flag19}
                            flag20={this.state.flag20}


                            caddieTypes={this.state.caddieTypes}
                            cartTypes={this.state.cartTypes}
                            roundTypes={this.state.roundTypes}

                            secretKeys={this.state.secretKeys}
                            onlySecret={this.state.onlySecret}

                            planIds={this.state.planIds}
                            onlySpecifiedPlanIds={this.state.onlySpecifiedPlanIds}

                            standardRsvn={this.state.standardRsvn}
                            soloRsvn={this.state.soloRsvn}

                            showIconLegendPc={this.state.showIconLegendPc}
                            showIconLegendSp={this.state.showIconLegendSp}
                            onMouseOver={() => this.handleIconLegendPc(true)}
                            onMouseOut={() => this.handleIconLegendPc(false)}
                        />
                    </MediaQuery>
                    <MediaQuery maxWidth={991}>
                        <SpCalendarTable
                            calendarName={this.state.calendarName}

                            monday={this.state.monday}
                            tuesday={this.state.tuesday}
                            wednesday={this.state.wednesday}
                            thursday={this.state.thursday}
                            friday={this.state.friday}
                            saturday={this.state.saturday}
                            sunday={this.state.sunday}
                            holiday={this.state.holiday}
                            weekdays={this.state.weekdays}
                            weekend={this.state.weekend}

                            hour5={this.state.hour5}
                            hour6={this.state.hour6}
                            hour7={this.state.hour7}
                            hour8={this.state.hour8}
                            hour9={this.state.hour9}
                            hour10={this.state.hour10}
                            hour11={this.state.hour11}
                            hour12={this.state.hour12}
                            hourRequest={this.state.hourRequest}

                            twosome={this.state.twosome}
                            flagLunch={this.state.flagLunch}
                            flagThrough={this.state.flagThrough}

                            flag01={this.state.flag01}
                            flag02={this.state.flag02}
                            flag03={this.state.flag03}
                            flag04={this.state.flag04}
                            flag05={this.state.flag05}
                            flag06={this.state.flag06}
                            flag07={this.state.flag07}
                            flag08={this.state.flag08}
                            flag09={this.state.flag09}
                            flag10={this.state.flag10}
                            flag11={this.state.flag11}
                            flag12={this.state.flag12}
                            flag13={this.state.flag13}
                            flag14={this.state.flag14}
                            flag15={this.state.flag15}
                            flag16={this.state.flag16}
                            flag17={this.state.flag17}
                            flag18={this.state.flag18}
                            flag19={this.state.flag19}
                            flag20={this.state.flag20}

                            displayOrder={this.state.displayOrder}

                            selectedMonth={this.state.selectedMonth}
                            monthCalendars={this.state.monthCalendars}
                            plans={this.state.plans}
                            courses={this.state.courses}

                            selectedDate={this.state.selectedDate}

                            secretKeys={this.state.secretKeys}
                            onlySecret={this.state.onlySecret}

                            planIds={this.state.planIds}
                            onlySpecifiedPlanIds={this.state.onlySpecifiedPlanIds}

                            standardRsvn={this.state.standardRsvn}
                            soloRsvn={this.state.soloRsvn}

                            onClick={(datePlans, date) => this.handleSpCalendarCellClick(datePlans, date)}
                        />

                        <div ref={this.state.myRef}></div>

                        <SpPlanList
                            calendarName={this.state.calendarName}
                            date={this.state.selectedDate}
                            datePlans={this.state.datePlans}

                            caddieTypes={this.state.caddieTypes}
                            cartTypes={this.state.cartTypes}
                            roundTypes={this.state.roundTypes}

                            secretKeys={this.state.secretKeys}
                            onlySecret={this.state.onlySecret}
                            planIds={this.state.planIds}
                            onlySpecifiedPlanIds={this.state.onlySpecifiedPlanIds}

                            twosomeOnPlanIconUrl={this.state.twosomeOnPlanIconUrl}
                            twosomeOffPlanIconUrl={this.state.twosomeOffPlanIconUrl}
                            lunchOnPlanIconUrl={this.state.lunchOnPlanIconUrl}
                            lunchOffPlanIconUrl={this.state.lunchOffPlanIconUrl}
                            throughOnPlanIconUrl={this.state.throughOnPlanIconUrl}
                            throughOffPlanIconUrl={this.state.throughOffPlanIconUrl}


                            showIconLegend={this.state.showIconLegend}
                            showIconLegendSp={this.state.showIconLegendSp}
                            onClick={() => this.handleIconLegendSp()}
                        />
                    </MediaQuery>
                </div>

                <div id="updated-at">
                    最終更新：{format( new Date(this.state.updatedAt), 'YYYY/MM/DD HH:mm:ss')}
                    &nbsp;&nbsp;
                    <RefetchButton
                        onClick={() => this.fetchCalendarData(true)}
                    />

                </div>
            </div>
        );
    }
}

class OnlySpecifiedPlanIdsSelector extends React.Component {
    render(){
        if(!this.props.planIds){ return ''}
        return(
            <div className="form-group">
                <label>プラン指定</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-onlySpecifiedPlanIds" value="1" checked={this.props.onlySpecifiedPlanIds} onChange={(e) => this.props.onChange('onlySpecifiedPlanIds', e.target.checked)} />
                    <label htmlFor="cb-onlySpecifiedPlanIds">指定プランのみ表示</label>
                </div>
            </div>
        )
    }
}

class OnlySecretSelector extends React.Component {
    render(){
        if(!this.props.secretKeys){ return ''}
        return(
            <div className="form-group">
                <label>シークレット設定</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-onlySecret" value="1" checked={this.props.onlySecret} onChange={(e) => this.props.onChange('onlySecret', e.target.checked)} />
                    <label htmlFor="cb-onlySecret">シークレットプランのみ表示</label>
                </div>
            </div>
        )
    }
}

class RsvnTypeSelector extends React.Component {
    render(){
        return(
            <div className="form-group">
                <label>予約タイプ</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-standardRsvn" value="1" checked={this.props.standardRsvn} onChange={(e) => this.props.onChange('standardRsvn', e.target.checked)} />
                    <label htmlFor="cb-standardRsvn">通常予約</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-soloRsvn" value="1" checked={this.props.soloRsvn} onChange={(e) => this.props.onChange('soloRsvn', e.target.checked)} />
                    <label htmlFor="cb-soloRsvn">一人予約</label>
                </div>
            </div>
        )
    }
}

class WdaySelector extends React.Component {
    render() {
        return(
            <div className="form-group">
                <label>曜日</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-monday" value="1" checked={this.props.monday} onChange={(e) => this.props.onChange('monday', e.target.checked)} />
                    <label htmlFor="cb-monday">月</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-tuesday" value="1" checked={this.props.tuesday} onChange={(e) => this.props.onChange('tuesday', e.target.checked)} />
                    <label htmlFor="cb-tuesday">火</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-wednesday" value="1" checked={this.props.wednesday} onChange={(e) => this.props.onChange('wednesday', e.target.checked)} />
                    <label htmlFor="cb-wednesday">水</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-thursday" value="1" checked={this.props.thursday} onChange={(e) => this.props.onChange('thursday', e.target.checked)} />
                    <label htmlFor="cb-thursday">木</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-friday" value="1" checked={this.props.friday} onChange={(e) => this.props.onChange('friday', e.target.checked)} />
                    <label htmlFor="cb-friday">金</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-saturday" value="1" checked={this.props.saturday} onChange={(e) => this.props.onChange('saturday', e.target.checked)} />
                    <label htmlFor="cb-saturday">土</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-sunday" value="1" checked={this.props.sunday} onChange={(e) => this.props.onChange('sunday', e.target.checked)} />
                    <label htmlFor="cb-sunday">日</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-holiday" value="1" checked={this.props.holiday} onChange={(e) => this.props.onChange('holiday', e.target.checked)} />
                    <label htmlFor="cb-holiday">祝</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-weekdays" value="1" checked={this.props.weekdays} onChange={(e) => this.props.onChange('weekdays', e.target.checked)} />
                    <label htmlFor="cb-weekdays">平日</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-weekend" value="1" checked={this.props.weekend} onChange={(e) => this.props.onChange('weekend', e.target.checked)} />
                    <label htmlFor="cb-weekend">土日祝</label>
                </div>
            </div>
        );
    }
}

class HourSelector extends React.Component {
    render() {
        return(
            <div className="form-group">
                <label>時間帯</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour5" value="1" checked={this.props.hour5} onChange={(e) => this.props.onChange('hour5', e.target.checked)} />
                    <label htmlFor="cb-hour5">～5時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour6" value="1" checked={this.props.hour6} onChange={(e) => this.props.onChange('hour6', e.target.checked)} />
                    <label htmlFor="cb-hour6">6時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour7" value="1" checked={this.props.hour7} onChange={(e) => this.props.onChange('hour7', e.target.checked)} />
                    <label htmlFor="cb-hour7">7時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour8" value="1" checked={this.props.hour8} onChange={(e) => this.props.onChange('hour8', e.target.checked)} />
                    <label htmlFor="cb-hour8">8時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour9" value="1" checked={this.props.hour9} onChange={(e) => this.props.onChange('hour9', e.target.checked)} />
                    <label htmlFor="cb-hour9">9時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour10" value="1" checked={this.props.hour10} onChange={(e) => this.props.onChange('hour10', e.target.checked)} />
                    <label htmlFor="cb-hour10">10時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour11" value="1" checked={this.props.hour11} onChange={(e) => this.props.onChange('hour11', e.target.checked)} />
                    <label htmlFor="cb-hour11">11時台</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hour12" value="1" checked={this.props.hour12} onChange={(e) => this.props.onChange('hour12', e.target.checked)} />
                    <label htmlFor="cb-hour12">12時台～</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-hourRequest" value="1" checked={this.props.hourRequest} onChange={(e) => this.props.onChange('hourRequest', e.target.checked)} />
                    <label htmlFor="cb-hourRequest">リクエスト</label>
                </div>
            </div>
        );
    }
}

class FlagSelector extends React.Component {
    render() {
        return(
            <div className="form-group">
                <label>オプション</label>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-twosome" value="1" checked={this.props.twosome} onChange={(e) => this.props.onChange('twosome', e.target.checked)} />
                    <label htmlFor="cb-twosome">2B保証</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-flagLunch" value="1" checked={this.props.flagLunch} onChange={(e) => this.props.onChange('flagLunch', e.target.checked)} />
                    <label htmlFor="cb-flagLunch">昼食付</label>
                </div>
                <div className="icheck-default">
                    <input type="checkbox" id="cb-flagThrough" value="1" checked={this.props.flagThrough} onChange={(e) => this.props.onChange('flagThrough', e.target.checked)} />
                    <label htmlFor="cb-flagThrough">スループレー</label>
                </div>
                {this.props.flags.map((flag) => {
                    let type  = flag.type.toLowerCase();
                    if(flag.isSearchOption){
                        return(
                            <div className="icheck-default" key={type}>
                                <input type="checkbox" id={'cb-' + type} value="1" checked={this.props[type]} onChange={(e) => this.props.onChange(type, e.target.checked)} />
                                <label htmlFor={'cb-' + type}>{flag.name}</label>
                            </div>
                        );
                    } else {
                    }
                })}
            </div>
        );
    }
}

class AllClearButton extends React.Component {
    render() {
        return(
            <div className={this.props.accordionOpened ? "form-group plan_filter_reset show" : "form-group plan_filter_reset"}>
                <button type="button" onClick={() => this.props.onClick()}>絞込解除</button>
            </div>
        );
    }
}

class RefetchButton extends React.Component {
    render() {
        return(
            <img src="/images/icon_refresh.svg" alt="" onClick={() => this.props.onClick()} />
        );
    }
}

class OrderSelector extends React.Component{
    render(){
        return(
            <div id="ordering-plan">
                <label>並び替え</label>
                <select name="" id="order" value={this.props.displayOrder} onChange={(e) => this.props.onChange(e)}>
                    <option value="recommend">おすすめ順</option>
                    <option value="lowPrice">料金が安い順</option>
                    <option value="highPrice">料金が高い順</option>
                </select>
            </div>
        );
    }
}

class CalendarFreeText extends React.Component {
    render(){
        if(!this.props.calendarFreeText){ return(<></>); } //テキストが空もしくは表示期間外だった場合表示しない
        return(
            <div id="calendar-free-text-container">
                <div dangerouslySetInnerHTML={{__html: this.props.calendarFreeText}} />
            </div>
        );
    }
}

class MonthSelector extends React.Component {
    render() {
        return(
            <div className="month_selector">
                {this.props.months.map((month) => {
                    let mm   = parseInt(month.substr(4,2), 10);
                    if(this.props.selectedMonth === month){
                        if(mm == "0"){
                            return <button key={month} type="button" className="selected"><span className="num">直近1ヶ月</span></button>;
                        } else {
                            return <button key={month} type="button" className="selected"><span className="num">{mm}月</span></button>;
                        }
                    } else {
                        if(mm == "0"){
                            return <button key={month} type="button" className="" onClick={() => this.props.onClick({month})}><span className="num">直近1ヶ月</span></button>;
                        } else {
                            return <button key={month} type="button" className="" onClick={() => this.props.onClick({month})}><span className="num">{mm}月</span></button>;
                        }

                    }
                })}
            </div>
        );
    }
}

class PcCalendarTable extends React.Component {
    handleCellClick(plan, planDate, date) {
        if(!plan.isReservable && !plan.isRequestable && !plan.isCancelReservable){ return; } // 11/13 キャンセル待ち機能追加対応
        const rsvnUrl    = `/calendars/${this.props.calendarName}/${plan.planTypeId == 1 ? 'standard_web_rsvns/show_slots' : 'solo_web_rsvns/show_slots'}?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        const requestUrl = `/calendars/${this.props.calendarName}/requests/new?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        const cancelRsvnUrl = `/calendars/${this.props.calendarName}/cancel_rsvns/confirm_create?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        if(plan.isReservable){
            if(planDate.hours){
                popup_form_service.onclick_open(rsvnUrl);
                return;
            }
            if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                popup_form_service.onclick_open(cancelRsvnUrl);
                return;
            }
            if(planDate.isRequestable){
                popup_form_service.onclick_open(requestUrl);
                return;
            }
        }else{
            if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                popup_form_service.onclick_open(cancelRsvnUrl);
                return;
            }
            if(planDate.isRequestable){
                popup_form_service.onclick_open(requestUrl);
                return;
            }
        }
    }

    handlePlanClick(plan){
        const paramSecretKeys = this.props.secretKeys ? '&secretKeys=' + this.props.secretKeys : '';
        popup_form_service.onclick_open(`/calendars/${this.props.calendarName}/plans/${plan.id}?refresh=true${paramSecretKeys}`);
    }

    slotsTable(planDate, courses, month, day, date, plan){
        let html               = '';

        // プラン名と日付情報を出力する
        html += '<div class="title">' + plan.name + '</div>';
        html += '<div class="date"><strong>'  + date.y + '/' + parseInt(date.m, 10) + '/' + parseInt(date.d, 10) + '(' + date.dayLabel + ')' + '</strong>の空き枠状況</div>';


        // 予約枠がある場合はコース名と各時間帯の予約枠を出力する
        if(planDate.hours){
            html += '<table>';
            const hours = Object.keys(planDate.hours).sort();
            html += '<tr>';
            courses.forEach((course) => {
                html += '<th>時</th>';
                html += '<th>' + course.name + '</th>';
            });
            html += '</tr>';

            hours.forEach((hh) => {
                if(this.anyHourCondition() && this.searchingHours().includes(hh)){
                    html += '<tr style="color:#FF0000;font-weight:bold;">';
                } else {
                    html += '<tr>';
                }
                let firstCourseFlag = true;
                courses.forEach((course) => {
                    html += '<td class="hour">' + hh + '</td>';
                    html += '<td style="text-align:left;padding-left:5px;white-space: nowrap;">';
                    if(planDate.hours[hh]["courses"][course.id]){
                        const minutes = Object.keys(planDate.hours[hh]["courses"][course.id]["minutes"]).sort();
                        minutes.forEach((mi) => {
                            html += mi + '　';
                        });
                    }
                    html += '</td>';
                });
                html += '</tr>';
            });
            html += '</table>';
        }

        if(planDate.hours && plan.isReservable){
            html += '<div class="message">' + this.props.webReservableMark.name + '</div>';
        }

        if(planDate.hours && !plan.isReservable){
            html += '<div class="message">' + this.props.telReservableMark.name + '</div>';
        }

        if(planDate.isRequestable){
            html += '<div class="message">' + this.props.requestableMark.name + '</div>';
        }

        // 11/13 キャンセル待ち機能追加対応
        if(planDate.isCancelReservable){
            html += '<div class="message">' + this.props.cancelReservableMark.name + '</div>';
        }

        return html;
    }

    mark(plan, planDate){
        if(plan.isReservable){
            if(planDate.hours){
                // MEMO: 11/13 isRequestableで条件分岐しているが、どちらの場合も同じマークを返しているので不要な気がする
                if(planDate.isRequestable){
                    return <img src={this.props.webReservableMark.imageUrl} alt="" />;
                }else{
                    return <img src={this.props.webReservableMark.imageUrl} alt="" />;
                }
            }else{
                if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                    return <img src={this.props.cancelReservableMark.imageUrl} alt="" />;
                }else if(planDate.isRequestable){
                    return <img src={this.props.requestableMark.imageUrl} alt="" />;
                }else{
                    return '';
                }
            }
        }else{
            if(planDate.hours){
                if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                    return <img src={this.props.cancelReservableMark.imageUrl} alt="" />;
                }else if(planDate.isRequestable){
                    return <img src={this.props.requestableMark.imageUrl} alt="" />;
                }else{
                    return <img src={this.props.telReservableMark.imageUrl} alt="" />;
                }
            }else{
                if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                    return <img src={this.props.cancelReservableMark.imageUrl} alt="" />;
                }else if(planDate.isRequestable){
                    return <img src={this.props.requestableMark.imageUrl} alt="" />;
                }else{
                    return '';
                }
            }
        }
    }

    cell(plan, month, day, date, courses){
        if(date.outOfRange || date.isClosure || date.isBeforeRsvnStart){
            return (<td key={plan.id + '-' + month + '-' + day}  className={date.tdClassName}></td>);
        }

        const planDate = plan.planCalendar[month]["days"][date.ymd];

        if(!planDate){
            return (<td key={plan.id + '-' + month + '-' + day}  className={date.tdClassName}></td>);
        }

        return (
            <td key={plan.id + '-' + month + '-' + day}  className={date.tdClassName}>
                <a className="clickable" data-tip data-for={plan.id + '-' + month + '-' + day} data-html={true} onClick={() => this.handleCellClick(plan, planDate, date)}>{this.mark(plan, planDate)}</a>
                <ReactTooltip id={plan.id + '-' + month + '-' + day} className="schedule" html={true}>
                    {this.slotsTable(planDate, courses, month, day, date, plan)}
                </ReactTooltip>
            </td>
        );
    }

    anyHourCondition(){
        if(this.props.hour5
            || this.props.hour6
            || this.props.hour7
            || this.props.hour8
            || this.props.hour9
            || this.props.hour10
            || this.props.hour11
            || this.props.hour12){
            return true;
        }
        return false;
    }

    searchingHours(){
        let hours = [];

        if(this.props.hour5)    {hours.push(0);hours.push(1);hours.push(2);hours.push(3);hours.push(4);hours.push(5);}
        if(this.props.hour6)    {hours.push(6);}
        if(this.props.hour7)    {hours.push(7);}
        if(this.props.hour8)    {hours.push(8);}
        if(this.props.hour9)    {hours.push(9);}
        if(this.props.hour10)   {hours.push(10);}
        if(this.props.hour11)   {hours.push(11);}
        if(this.props.hour12)   {hours.push(12);hours.push(13);hours.push(14);hours.push(15);hours.push(16);hours.push(17);hours.push(18);hours.push(19);hours.push(20);hours.push(21);hours.push(22);hours.push(23);}

        //もし時間帯もリクエストも選択されていない場合は、全部検索対象にする
        if(hours.length == 0 && !this.props.hourRequest){
            hours = [...Array(24).keys()]; //[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]
        }

        return hours.map(num => this.zeroPadding(num));
    }

    zeroPadding(num){
        if(num < 10){
            return '0' + num;
        } else {
            return num;
        }
    }

    searchRequestable(){
        // 「時間帯」で「リクエスト」が選択されている場合
        if(this.props.hourRequest) {
            return true;
        }

        // 「時間帯」でいずれの時間帯もチェックされていない場合
        if(!this.props.hour5
        && !this.props.hour6
        && !this.props.hour7
        && !this.props.hour8
        && !this.props.hour9
        && !this.props.hour10
        && !this.props.hour11
        && !this.props.hour12){
            return true;
        }

        // それ以外(「時間帯」で「リクエスト」が選択されておらず、それ以外の「時間帯」が1つ以上チェックされている場合)
        return false;
    }

    checkWdaysAndHours(planDays){
        let result = false;

        let searchingHours    = this.searchingHours();
        let searchRequestable = this.searchRequestable();

        Object.keys(planDays).forEach((key) => {
            planDays[key]["matchedSlotNum"] = 0;
            planDays[key]["matchedRequestable"] = false;

            if(!this.checkWdays(key)){
                return;
            }


            searchingHours.forEach((searchingHour) => {
                if (planDays[key]["hours"] && planDays[key]["hours"][searchingHour]) {
                    result = true;
                    planDays[key]["matchedSlotNum"] += planDays[key]["hours"][searchingHour]["slots_num"];
                }
            });
            if (searchRequestable == true && planDays[key]["isRequestable"] == true) {
                result = true;
                planDays[key]["matchedRequestable"] = true;
            }
            // 11/13 キャンセル待ち機能追加対応(ここの処理で空き枠の時間帯とリクエスト可の条件で絞り込まれてしまうため必要。)
            // 「リクエスト可」にチェックを入れた場合にリクエスト可能プランとキャンセル可能プランの両方がTRUEになってしまうことになるが、
            // そもそも作成の時点でリクエストとキャンセル予約は併存できないようにしているので差し当たって問題はない。
            if (searchRequestable == true && planDays[key]["isCancelReservable"] == true) {
                result = true;
                planDays[key]["matchedRequestable"] = true;
            }
        });

        return result;
    };

    checkWdays(yyyymmdd){

        // 全曜日非選択の場合、全曜日OKなのでtrueを返す
        if( !this.props.monday &&
            !this.props.tuesday &&
            !this.props.wednesday &&
            !this.props.thursday &&
            !this.props.friday &&
            !this.props.saturday &&
            !this.props.sunday &&
            !this.props.holiday &&
            !this.props.weekdays &&
            !this.props.weekend) {
            return true;
        }

        let date = this.props.monthCalendars[this.props.selectedMonth][yyyymmdd];

        if(this.props.monday    && date.wday === 1 ){ return true; }
        if(this.props.tuesday   && date.wday === 2 ){ return true; }
        if(this.props.wednesday && date.wday === 3 ){ return true; }
        if(this.props.thursday  && date.wday === 4 ){ return true; }
        if(this.props.friday    && date.wday === 5 ){ return true; }
        if((this.props.saturday  || this.props.weekend)  && date.wday === 6 ){ return true; }
        if((this.props.sunday    || this.props.weekend)  && date.wday === 0 ){ return true; }
        if((this.props.holiday   || this.props.weekend)  && date.holiday != null ){ return true; }

        //平日で絞り込む場合は祝日でない月～金かどうかで判定する
        let weekdays = [1,2,3,4,5];
        if(this.props.weekdays && weekdays.includes(date.wday) && date.holiday === null ){ return true; }

        return false;
    };

    displayIcons(plan){

        let icons = [];

        icons.push(this.props.caddieTypes.find(element => element.id == plan.caddieTypeId).iconUrl);
        icons.push(this.props.cartTypes.find(element => element.id == plan.cartTypeId).iconUrl);
        icons.push(this.props.roundTypes.find(element => element.id == plan.roundTypeId).iconUrl);

        if(plan.is2bGuaranteed){
            icons.push(this.props.twosomeOnPlanIconUrl);
        } else {
            icons.push(this.props.twosomeOffPlanIconUrl);
        }
        if(plan.flagLunch){
            icons.push(this.props.lunchOnPlanIconUrl);
        } else {
            icons.push(this.props.lunchOffPlanIconUrl);
        }
        if(plan.flagThrough){
            icons.push(this.props.throughOnPlanIconUrl);
        } else {
            icons.push(this.props.throughOffPlanIconUrl);
        }

        return icons;
    }

    // ハッシュを指定されたキーと順序でソートするメソッド
    hashSort(hash, key, order = 'ASC') {
        // 引数エラー
        if (!hash || !key || (order != 'ASC' && order != 'DESC')){ return hash; }

        // ブール値として変数に代入(評価回数を1回にするため)
        const asc_flag = (order === 'ASC');

        // メイン処理
        hash.sort(function(a, b) {
            let a_value = a[key] == null ? null : Number(a[key])
            let b_value = b[key] == null ? null : Number(b[key])
            if (asc_flag) {
                if (a_value == null && b_value == null) return 0;
                if (a_value == null) return 1;
                if (b_value == null) return -1;
                return a_value > b_value ? 1 : -1;
            } else {
                if (a_value == null && b_value == null) return 0;
                if (a_value == null) return 1;
                if (b_value == null) return -1;
                return a_value < b_value ? 1 : -1;
            }
        });

        return hash;
    };


    render() {
        // 普通の代入だと参照渡しになりオリジナルに変更が及ぶためディープコピーしている。要素にDateオブジェクトなどが含まれていると
        // そのままコピーできないが、各要素とも日付/時刻情報であっても文字列に過ぎないので大丈夫。
        // cf.) https://qiita.com/knhr__/items/d7de463bf9013d5d3dc0
        let plans                 = JSON.parse(JSON.stringify(this.props.plans));
        let selectedMonth         = this.props.selectedMonth;
        let selectedMonthCalendar = this.props.monthCalendars[selectedMonth];
        let courses               = this.props.courses;

        if(!selectedMonthCalendar){return (<div className={"alert alert-light m-2"}>カレンダーデータが見つかりませんでした</div>);}

        if(this.props.planIds && this.props.onlySpecifiedPlanIds){
            let planIds = this.props.planIds.split(',');
            console.log(planIds);
            plans = plans.filter((plan) => planIds.includes(String(plan.id)));
        }


        // Filter plans by search form conditions.
        if(this.props.standardRsvn && !this.props.soloRsvn){
            plans = plans.filter((plan) => plan.planTypeId == 1);
        }
        if(!this.props.standardRsvn && this.props.soloRsvn){
            plans = plans.filter((plan) => plan.planTypeId == 2);
        }


        if(this.props.twosome){
            plans = plans.filter((plan) => plan.is2bGuaranteed == true);
        }
        if(this.props.flagLunch){
            plans = plans.filter((plan) => plan.flagLunch == true);
        }
        if(this.props.flagThrough){
            plans = plans.filter((plan) => plan.flagThrough == true);
        }
        if(this.props.flag01){
            plans = plans.filter((plan) => plan.flag01 == true);
        }
        if(this.props.flag02){
            plans = plans.filter((plan) => plan.flag02 == true);
        }
        if(this.props.flag03){
            plans = plans.filter((plan) => plan.flag03 == true);
        }
        if(this.props.flag04){
            plans = plans.filter((plan) => plan.flag04 == true);
        }
        if(this.props.flag05){
            plans = plans.filter((plan) => plan.flag05 == true);
        }
        if(this.props.flag06){
            plans = plans.filter((plan) => plan.flag06 == true);
        }
        if(this.props.flag07){
            plans = plans.filter((plan) => plan.flag07 == true);
        }
        if(this.props.flag08){
            plans = plans.filter((plan) => plan.flag08 == true);
        }
        if(this.props.flag09){
            plans = plans.filter((plan) => plan.flag09 == true);
        }
        if(this.props.flag10){
            plans = plans.filter((plan) => plan.flag10 == true);
        }
        if(this.props.flag11){
            plans = plans.filter((plan) => plan.flag11 == true);
        }
        if(this.props.flag12){
            plans = plans.filter((plan) => plan.flag12 == true);
        }
        if(this.props.flag13){
            plans = plans.filter((plan) => plan.flag13 == true);
        }
        if(this.props.flag14){
            plans = plans.filter((plan) => plan.flag14 == true);
        }
        if(this.props.flag15){
            plans = plans.filter((plan) => plan.flag15 == true);
        }
        if(this.props.flag16){
            plans = plans.filter((plan) => plan.flag16 == true);
        }
        if(this.props.flag17){
            plans = plans.filter((plan) => plan.flag17 == true);
        }
        if(this.props.flag18){
            plans = plans.filter((plan) => plan.flag18 == true);
        }
        if(this.props.flag19){
            plans = plans.filter((plan) => plan.flag19 == true);
        }
        if(this.props.flag20){
            plans = plans.filter((plan) => plan.flag20 == true);
        }


        if(this.props.onlySecret){
            plans = plans.filter((plan) => plan.isSecret == true);
        }

        // 選択月のカレンダーが存在するプランであること
        plans = plans.filter((plan) => plan.planCalendar[selectedMonth]);

        // 曜日・時間帯条件に合致するプランであること
        plans = plans.filter((plan) => this.checkWdaysAndHours(plan.planCalendar[selectedMonth]["days"]));

        // 並び替え
        if(this.props.displayOrder === 'recommend'){
            plans = this.hashSort(plans, 'sort', 'ASC');
        }
        if(this.props.displayOrder === 'lowPrice'){
            plans = this.hashSort(plans, 'feeIncludingTax', 'ASC');
        }
        if(this.props.displayOrder === 'highPrice'){
            plans = this.hashSort(plans, 'feeIncludingTax', 'DESC');
        }
        if(this.props.displayOrder === 'availableSlots'){
            plans = this.hashSort(plans, 'allSlotsNum', 'DESC');
        }

        const dayNums = Object.keys(selectedMonthCalendar).sort();

        return(
            <table className="pc_calendar">
                <thead>
                    <tr>
                        <th className="plan_name">プラン</th>
                        <th className="plan_icon">
                            <span data-tip data-for="plan_icon_legend">内容 <img src={"/images/icon_help.svg"} alt="" className="icon_help" /></span>
                            <ReactTooltip id="plan_icon_legend">
                                <PlanIconLegend
                                    device={'PC'}
                                    showIconLegendPc={this.props.showIconLegendPc}
                                    showIconLegendSp={this.props.showIconLegendSp}

                                    caddieTypes={this.props.caddieTypes}
                                    cartTypes={this.props.cartTypes}
                                    roundTypes={this.props.roundTypes}

                                    twosomeOnPlanIconUrl={this.props.twosomeOnPlanIconUrl}
                                    twosomeOffPlanIconUrl={this.props.twosomeOffPlanIconUrl}
                                    lunchOnPlanIconUrl={this.props.lunchOnPlanIconUrl}
                                    lunchOffPlanIconUrl={this.props.lunchOffPlanIconUrl}
                                    throughOnPlanIconUrl={this.props.throughOnPlanIconUrl}
                                    throughOffPlanIconUrl={this.props.throughOffPlanIconUrl}
                                />
                            </ReactTooltip>
                        </th>
                        <th className="plan_fee">料金</th>
                        {dayNums.map(dayNum => (
                            <th key={dayNum} className={selectedMonthCalendar[dayNum].thClassName}>
                                <span className="num">{parseInt(selectedMonthCalendar[dayNum].d, 10)}</span>
                                {selectedMonthCalendar[dayNum].dayLabel}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {plans.map((plan, i) => {
                        return (
                            <React.Fragment key={plan.id}>
                                {/* 5行おきにヘッダー行を表示する */}
                                {/* https://qiita.com/horiy0125/items/fa07f5baa6028b9746ce */}
                                {(i!=0 && i%5===0) &&
                                    <tr>
                                        <th className="plan_name">プラン</th>
                                        <th className="plan_icon">
                                            <span data-tip data-for={`plan_icon_legend-${i}`}>内容 <img src={"/images/icon_help.svg"} alt="" className="icon_help" /></span>
                                            <ReactTooltip id={`plan_icon_legend-${i}`}>
                                                <PlanIconLegend
                                                    device={'PC'}
                                                    showIconLegendPc={this.props.showIconLegendPc}
                                                    showIconLegendSp={this.props.showIconLegendSp}

                                                    caddieTypes={this.props.caddieTypes}
                                                    cartTypes={this.props.cartTypes}
                                                    roundTypes={this.props.roundTypes}

                                                    twosomeOnPlanIconUrl={this.props.twosomeOnPlanIconUrl}
                                                    twosomeOffPlanIconUrl={this.props.twosomeOffPlanIconUrl}
                                                    lunchOnPlanIconUrl={this.props.lunchOnPlanIconUrl}
                                                    lunchOffPlanIconUrl={this.props.lunchOffPlanIconUrl}
                                                    throughOnPlanIconUrl={this.props.throughOnPlanIconUrl}
                                                    throughOffPlanIconUrl={this.props.throughOffPlanIconUrl}
                                                />
                                            </ReactTooltip>
                                        </th>
                                        <th className="plan_fee">料金</th>
                                        {dayNums.map(dayNum => (
                                            <th key={dayNum} className={selectedMonthCalendar[dayNum].thClassName}>
                                                <span className="num">{parseInt(selectedMonthCalendar[dayNum].d, 10)}</span>
                                                {selectedMonthCalendar[dayNum].dayLabel}
                                            </th>
                                        ))}
                                    </tr>
                                }
                                <tr>
                                    <td className="plan_name">
                                        <a className="clickable" onClick={() => this.handlePlanClick(plan)}>{plan.name}</a>
                                        {plan.isSecret ? plan.planTypeId == 1 ? <span className="secret">シークレット</span> : <span className="secret with_solo">シークレット</span> : ''}
                                        {plan.planTypeId == 1 ? '' : <span className="solo_rsv">一人予約</span>}
                                    </td>
                                    <td className="plan_icon">
                                        {this.displayIcons(plan).map((icon)=>{
                                            return <img key={plan.id + '-' + icon} src={icon}/>;
                                        })}
                                    </td>
                                    <td className="plan_fee">
                                        <span className="text-lg num">{plan.feeExcludingTax.toLocaleString()}</span>円<br /><span className="text-sm">総額：{plan.feeIncludingTax.toLocaleString()}円</span>
                                    </td>
                                    {dayNums.map(dayNum => (
                                        this.cell(plan, selectedMonth, selectedMonthCalendar[dayNum].d, selectedMonthCalendar[dayNum], courses)
                                    ))}
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}

class PlanIconLegend extends React.Component {
    render(){
        return(
            <div className={this.props.device == 'PC' && this.props.showIconLegendPc || this.props.device == 'SP' && this.props.showIconLegendSp ? "plan_icon_legend show" : "plan_icon_legend"}>
                <div>
                    <table>
                        <tbody>
                            {this.props.caddieTypes.map(caddieType => (
                                <tr key={caddieType.id}>
                                    <td><img src={caddieType.iconUrl} /></td>
                                    <td className="name">{caddieType.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                            {this.props.cartTypes.map(cartType => (
                                <tr key={cartType.id}>
                                    <td><img src={cartType.iconUrl} /></td>
                                    <td className="name">{cartType.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                            {this.props.roundTypes.map(roundType => (
                                <tr key={roundType.id}>
                                    <td><img src={roundType.iconUrl} /></td>
                                    <td className="name">{roundType.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                        <tr>
                            <td><img src={this.props.twosomeOnPlanIconUrl} /></td>
                            <td className="name">２サム保証あり</td>
                        </tr>
                        <tr>
                            <td><img src={this.props.twosomeOffPlanIconUrl} /></td>
                            <td className="name">２サム保証なし</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                        <tr>
                            <td><img src={this.props.lunchOnPlanIconUrl} /></td>
                            <td className="name">昼食付き</td>
                        </tr>
                        <tr>
                            <td><img src={this.props.lunchOffPlanIconUrl} /></td>
                            <td className="name">昼食なし</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                        <tr>
                            <td><img src={this.props.throughOnPlanIconUrl} /></td>
                            <td className="name">スループレー</td>
                        </tr>
                        <tr>
                            <td><img src={this.props.throughOffPlanIconUrl} /></td>
                            <td className="name">スループレーでない</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}





class PcMarkLegend extends React.Component {
    renderCalendarMark(obj){
      if(!obj.displayLegend){ //カレンダーページ表示フラグがfalseだった場合は描画しない
        return;
      }
      return(
        <li><img src={obj.imageUrl} alt="" />{obj.name}</li>
      );
    }
    render(){
        return(
            <div className="icon_notes">
                <ul>
                    {this.renderCalendarMark(this.props.webReservableMark)}
                    {this.renderCalendarMark(this.props.requestableMark)}
                    {this.renderCalendarMark(this.props.telReservableMark)}
                    {this.renderCalendarMark(this.props.cancelReservableMark)}
                </ul>
            </div>
        ); // 11/13 キャンセル待ち機能追加対応
    }
}


// SP版カレンダーテーブル
class SpCalendarTable extends React.Component {

    organizeWeeks(monthCalendar){
        const dayNums = Object.keys(monthCalendar).sort();

        let week      = [];
        let weeks     = [];

        let first_flag = true;
        dayNums.forEach((dayNum) => {
            if(first_flag){
                for(let i=0; i < monthCalendar[dayNum].wday; i++){
                    week.push("dummy");
                }
            }
            week.push(dayNum);

            if(week.length == 7){
                weeks.push(week);
                week = [];
            }
            first_flag = false;
        })

        if(week.length != 0){
            for(let i=week.length; i < 7; i++){
                week.push("dummy");
            }
            weeks.push(week);
        }

        return weeks;
    }


    render() {
        // 普通の代入だと参照渡しになりオリジナルに変更が及ぶためディープコピーしている。要素にDateオブジェクトなどが含まれていると
        // そのままコピーできないが、各要素とも日付/時刻情報であっても文字列に過ぎないので大丈夫。
        // cf.) https://qiita.com/knhr__/items/d7de463bf9013d5d3dc0
        let plans                 = JSON.parse(JSON.stringify(this.props.plans));

        const selectedMonth         = this.props.selectedMonth;
        const selectedMonthCalendar = this.props.monthCalendars[selectedMonth];

        if(!selectedMonthCalendar){return (<div className={"alert alert-light m-2"}>カレンダーデータが見つかりませんでした</div>);}

        const weeks = this.organizeWeeks(selectedMonthCalendar);

        // Filter plans by search form conditions.
        if(this.props.standardRsvn && !this.props.soloRsvn){
            plans = plans.filter((plan) => plan.planTypeId == 1);
        }
        if(!this.props.standardRsvn && this.props.soloRsvn){
            plans = plans.filter((plan) => plan.planTypeId == 2);
        }

        if(this.props.twosome){
            plans = plans.filter((plan) => plan.is2bGuaranteed == true);
        }
        if(this.props.flagLunch){
            plans = plans.filter((plan) => plan.flagLunch == true);
        }
        if(this.props.flagThrough){
            plans = plans.filter((plan) => plan.flagThrough == true);
        }
        if(this.props.flag01){
            plans = plans.filter((plan) => plan.flag01 == true);
        }
        if(this.props.flag02){
            plans = plans.filter((plan) => plan.flag02 == true);
        }
        if(this.props.flag03){
            plans = plans.filter((plan) => plan.flag03 == true);
        }
        if(this.props.flag04){
            plans = plans.filter((plan) => plan.flag04 == true);
        }
        if(this.props.flag05){
            plans = plans.filter((plan) => plan.flag05 == true);
        }
        if(this.props.flag06){
            plans = plans.filter((plan) => plan.flag06 == true);
        }
        if(this.props.flag07){
            plans = plans.filter((plan) => plan.flag07 == true);
        }
        if(this.props.flag08){
            plans = plans.filter((plan) => plan.flag08 == true);
        }
        if(this.props.flag09){
            plans = plans.filter((plan) => plan.flag09 == true);
        }
        if(this.props.flag10){
            plans = plans.filter((plan) => plan.flag10 == true);
        }
        if(this.props.flag11){
            plans = plans.filter((plan) => plan.flag11 == true);
        }
        if(this.props.flag12){
            plans = plans.filter((plan) => plan.flag12 == true);
        }
        if(this.props.flag13){
            plans = plans.filter((plan) => plan.flag13 == true);
        }
        if(this.props.flag14){
            plans = plans.filter((plan) => plan.flag14 == true);
        }
        if(this.props.flag15){
            plans = plans.filter((plan) => plan.flag15 == true);
        }
        if(this.props.flag16){
            plans = plans.filter((plan) => plan.flag16 == true);
        }
        if(this.props.flag17){
            plans = plans.filter((plan) => plan.flag17 == true);
        }
        if(this.props.flag18){
            plans = plans.filter((plan) => plan.flag18 == true);
        }
        if(this.props.flag19){
            plans = plans.filter((plan) => plan.flag19 == true);
        }
        if(this.props.flag20){
            plans = plans.filter((plan) => plan.flag20 == true);
        }

        if(this.props.planIds && this.props.onlySpecifiedPlanIds){
            let planIds = this.props.planIds.split(',');
            console.log(planIds);
            plans = plans.filter((plan) => planIds.includes(String(plan.id)));
        }

        if(this.props.onlySecret){
            plans = plans.filter((plan) => plan.isSecret == true);
        }


        return(
            <table className="sp_calendar">
                <thead>
                    <tr>
                        <th className="sunday">日</th>
                        <th>月</th>
                        <th>火</th>
                        <th>水</th>
                        <th>木</th>
                        <th>金</th>
                        <th className="saturday">土</th>
                    </tr>
                </thead>
                <tbody>
                {weeks.map((week, w_idx) => {
                    return(
                        <tr key={"row" + w_idx}>
                            {week.map((dayNum, d_idx) => {
                                return(
                                    <SpCalendarCell
                                        key={"row" + w_idx + "_col" + d_idx}
                                        plans={plans}
                                        date={selectedMonthCalendar[dayNum]}
                                        dayNum={dayNum}
                                        selectedDate={this.props.selectedDate}
                                        onClick={(datePlans, date) => this.props.onClick(datePlans, date)}
                                    />
                                )
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        );
    }
}

// SP版カレンダーテーブルの各日付セル
class SpCalendarCell extends React.Component {

    render(){
        if(this.props.dayNum == "dummy"){return(<td className="dummy disabled"></td>)}

        const plans  = this.props.plans;
        const date   = this.props.date;
        const yyyymm = date.y + date.m;
        const dd     = date.d;
        const ymd    = date.ymd;

        if(date.outOfRange || date.isClosure || date.isBeforeRsvnStart){return(<td className={date.tdClassName + " disabled"}><span className="dd">{parseInt(dd, 10)}</span></td>)}

        const uniqueSlotSet = new Set(); // ArrayでなくSetを使うとユニークになる
        let datePlans = [];
        let isRequestable = false;
        let otherLabel = "";

        plans.forEach((plan) =>{
            if(plan["planCalendar"][yyyymm] && plan["planCalendar"][yyyymm]["days"] && plan["planCalendar"][yyyymm]["days"][ymd]){
                if(plan["planCalendar"][yyyymm]["days"][ymd]["isRequestable"]){
                    isRequestable = true;
                    otherLabel    = "リクOK";
                }
                // 11/13 キャンセル待ち機能追加対応
                if(plan["planCalendar"][yyyymm]["days"][ymd]["isCancelReservable"]){
                    isRequestable = true;
                    otherLabel    = "空き待可";
                }
                if(plan["planCalendar"][yyyymm]["days"][ymd]["hours"]){
                    let hours = Object.keys(plan["planCalendar"][yyyymm]["days"][ymd]["hours"]);
                    hours.forEach((hour) =>{
                        let courses = Object.keys(plan["planCalendar"][yyyymm]["days"][ymd]["hours"][hour]["courses"]);
                        courses.forEach((course) =>{
                            let minutes = Object.keys(plan["planCalendar"][yyyymm]["days"][ymd]["hours"][hour]["courses"][course]["minutes"]);
                            minutes.forEach((minute) =>{
                                uniqueSlotSet.add(course + "-" + hour + ":" + minute);
                            })
                        })
                    })
                }
                datePlans.push(plan);
            }
        });

        if(uniqueSlotSet.size == 0 && !isRequestable){return(<td className={date.tdClassName + " disabled"}><span className="dd">{parseInt(dd, 10)}</span></td>)}

        let classes = `${date.tdClassName}`;
        if(this.props.selectedDate == date){
            classes = classes + " selected";
        }

        const check = isRequestable ? "✔" : "－";

        return(
            <td className={classes} onClick={() => this.props.onClick(datePlans, date)}>
                <span className="dd">{parseInt(dd, 10)}</span><br />
                <span className="slotNum">{uniqueSlotSet.size > 0 ? uniqueSlotSet.size + '枠' : otherLabel}</span>
            </td>
        )
    }
}

// SP版カレンダーテーブルの各日付セルをクリックし画面下部に表示されるプランリスト
class SpPlanList extends React.Component {
    render() {
        const datePlans = this.props.datePlans;
        const date  = this.props.date;

        if (!date || Object.keys(date).length == 0) {
            return <div></div>
        }
        return (
            <div className="sp_plan_list">
                <div className="selected_date">
                    {date.y}年{parseInt(date.m, 10)}月{parseInt(date.d, 10)}日({date.dayLabel})
                </div>
                <div className="plan_icon" onClick={() => this.props.onClick()}>アイコン説明 <img src={"/images/icon_help.svg"} alt="" className="icon_help" /></div>
                <PlanIconLegend
                    device={'SP'}
                    showIconLegendPc={this.props.showIconLegendPc}
                    showIconLegendSp={this.props.showIconLegendSp}

                    caddieTypes={this.props.caddieTypes}
                    cartTypes={this.props.cartTypes}
                    roundTypes={this.props.roundTypes}

                    twosomeOnPlanIconUrl={this.props.twosomeOnPlanIconUrl}
                    twosomeOffPlanIconUrl={this.props.twosomeOffPlanIconUrl}
                    lunchOnPlanIconUrl={this.props.lunchOnPlanIconUrl}
                    lunchOffPlanIconUrl={this.props.lunchOffPlanIconUrl}
                    throughOnPlanIconUrl={this.props.throughOnPlanIconUrl}
                    throughOffPlanIconUrl={this.props.throughOffPlanIconUrl}
                />
                {datePlans.length > 0 ?
                    datePlans.map((plan) => {
                        return (
                            <SpPlan
                                key={plan.id}
                                plan={plan}
                                date={date}

                                caddieTypes={this.props.caddieTypes}
                                cartTypes={this.props.cartTypes}
                                roundTypes={this.props.roundTypes}

                                twosomeOnPlanIconUrl={this.props.twosomeOnPlanIconUrl}
                                twosomeOffPlanIconUrl={this.props.twosomeOffPlanIconUrl}
                                lunchOnPlanIconUrl={this.props.lunchOnPlanIconUrl}
                                lunchOffPlanIconUrl={this.props.lunchOffPlanIconUrl}
                                throughOnPlanIconUrl={this.props.throughOnPlanIconUrl}
                                throughOffPlanIconUrl={this.props.throughOffPlanIconUrl}

                                flags={this.props.flags}

                                calendarName={this.props.calendarName}
                            />
                        )
                    })
                    :
                    <p className="no_plan_available">予約またはリクエスト可能なプランがありません</p>
                }
            </div>
        )
    }
}

// SP版カレンダーテーブルの各日付セルをクリックし画面下部に表示されるプランリストの各プラン要素
class SpPlan extends React.Component {
    displayIcons(plan){

        let icons = [];

        icons.push(this.props.caddieTypes.find(element => element.id == plan.caddieTypeId).iconUrl);
        icons.push(this.props.cartTypes.find(element => element.id == plan.cartTypeId).iconUrl);
        icons.push(this.props.roundTypes.find(element => element.id == plan.roundTypeId).iconUrl);

        if(plan.is2bGuaranteed){
            icons.push(this.props.twosomeOnPlanIconUrl);
        } else {
            icons.push(this.props.twosomeOffPlanIconUrl);
        }
        if(plan.flagLunch){
            icons.push(this.props.lunchOnPlanIconUrl);
        } else {
            icons.push(this.props.lunchOffPlanIconUrl);
        }
        if(plan.flagThrough){
            icons.push(this.props.throughOnPlanIconUrl);
        } else {
            icons.push(this.props.throughOffPlanIconUrl);
        }

        return icons;
    }

    displayFlagIcons(plan){

        let icons = [];

        this.props.flags.forEach((flag) => {
            if(flag.isSelectable && flag.iconUrl && plan[flag.type.toLowerCase()]){
                icons.push(flag.iconUrl);
            }
        });

        return icons;
    }

    click(plan, planDate, date) {
        if(!plan.isReservable && !plan.isRequestable && !planDate.isCancelReservable){ return; } // 11/13 キャンセル待ち機能追加対応
        const rsvnUrl    = `/calendars/${this.props.calendarName}/${plan.planTypeId == 1 ? 'standard_web_rsvns/show_slots' : 'solo_web_rsvns/show_slots'}?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        const requestUrl = `/calendars/${this.props.calendarName}/requests/new?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        const cancelRsvnUrl = `/calendars/${this.props.calendarName}/cancel_rsvns/confirm_create?plan_id=${plan.id}&play_date=${date.y}-${date.m}-${date.d}&refresh=true`;
        if(plan.isReservable){
            if(planDate.hours){
                popup_form_service.onclick_open(rsvnUrl);
                return;
            }
            if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                popup_form_service.onclick_open(cancelRsvnUrl);
                return;
            }
            if(planDate.isRequestable){
                popup_form_service.onclick_open(requestUrl);
                return;
            }
        }else{
            if(planDate.isCancelReservable){ // 11/13 キャンセル待ち機能追加対応
                popup_form_service.onclick_open(cancelRsvnUrl);
                return;
            }
            if(planDate.isRequestable){
                popup_form_service.onclick_open(requestUrl);
                return;
            }
        }
    }

    render(){
        const plan   = this.props.plan;
        const date   = this.props.date;
        const yyyymm = date.y + date.m;
        const dd     = date.d;
        const ymd    = date.ymd;
        const planDate = plan.planCalendar[yyyymm]["days"][ymd];

        const slotsNum = plan["planCalendar"][yyyymm]["days"][ymd]["totalSlots"] ? plan["planCalendar"][yyyymm]["days"][ymd]["totalSlots"] : 0;

        let label = '';
        if(plan["planCalendar"][yyyymm]["days"][ymd]["isCancelReservable"]){ // 11/13 キャンセル待ち機能追加対応
            label = 'キャンセル待ち可';
        } else if(plan["planCalendar"][yyyymm]["days"][ymd]["isRequestable"]){
            label = 'リク可';
        } else if(slotsNum > 0  && !plan.isReservable){
            label = '電話受付';
        }

        return(
            <div className="plan" onClick={() => this.click(plan, planDate, date)}>
                <div className="plan_name"><span>{plan.name}</span></div>
                <div className="detail">
                    <div className="icons">
                        {plan.isSecret ? <div className="secret">シークレット</div> : ''}
                        {plan.planTypeId == 1 ? '' : <div className="solo_rsv">一人予約</div>}
                        {this.displayIcons(plan).map((icon)=>{ return <img src={icon}/>; })}
                    </div>
                    <div className="price">
                        <span className="num">{plan.feeExcludingTax.toLocaleString()}</span>円
                        <span className="text-sm">総額：{plan.feeIncludingTax.toLocaleString()}円</span>
                    </div>
                </div>
                <div className="vacancy">
                    {slotsNum > 0 ? <span className="num">{slotsNum}枠</span> : ''}
                    {label && <span className="request">{label}</span>}
                </div>
            </div>
        )
    }
}